import { Link, useNavigate } from 'react-router-dom';
import '../styles/nav-bar.css';
import logo from '../assets/images/joozylogo.png';

const Navbar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link className="navbar-brand" to="/">
          <img src={logo} alt="Joozy Logo" className="navbar-logo" />
        </Link>
        
        <ul className="navbar-menu">
          <li className="nav-item">
            <Link to="/dashboard" className="nav-link">Dashboard</Link>
          </li>
          <li className="nav-item">
            <Link to="/" className="nav-link">Form</Link>
          </li>
          <li className="nav-item">
            <Link to="/cards" className="nav-link">All Vendors</Link>
          </li>
          <li className="nav-item">
            <Link to="/table" className="nav-link">Table</Link>
          </li>
        </ul>

        <button className="btn-logout" onClick={handleLogout}>Logout</button>
      </div>
    </nav>
  );
};

export default Navbar;
